<!--
 * @Author: xiaokun
 * @Date: 2020-04-13 16:12:33
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-14 19:50:16
 * @Description: 左侧分数信息
 -->
<template>
  <div class="left-score-info">
    <div class="paper-score-info border-attribute">
      <div class="mb-10">
        考试名称：<span>{{ paperInfo.name }}</span>
      </div>
      <div class="mb-10">
        总题数：<span>{{ paperInfo.questionNum }}</span>
      </div>
      <div>总分数：<span>{{ paperInfo.score }}</span></div>
    </div>
    <div class="cur-scroe border-attribute">
      <div class="mb-10">
        答卷人：{{ employeeInfo.name }}
      </div>
      <div class="mb-10">
        当前成绩：
        <span :class="employeeInfo.pass === 1 || isPass?'passColor':'noPassColor'">
          <span v-if="isApprove">{{ curTotalScore }}</span>
          <span v-else>{{ employeeInfo.score }}</span>
          <!-- {{ curTotalScore || employeeInfo.score || 0 }} -->
        </span>
        分
      </div>
      <div>
        结果：
        <!-- 是否通过 1是2否 默认0 -->
        <span v-if="employeeInfo.pass === 1 || isPass ">
          <div class="passBgColor spot" />
          已通过
        </span>
        <span v-else>
          <div class="noPassBgColor spot" />
          未通过</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LeftScoreInfo',
  components: {},
  props: {
    // 是否为查看
    isApprove: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      params: {},
      paperInfo: {},
      employeeInfo: {}
    }
  },
  computed: {
    curTotalScore () {
      return this.$store.state['examination-manage'].curTotalScore
    },
    isPass () {
      return this.curTotalScore >= this.paperInfo.passScore
    }
  },
  created () {
    this.paperEmployeePaperSummaryGetParams()
  },
  methods: {
    // 接口参数
    paperEmployeePaperSummaryGetParams () {
      this.params = {
        paperId: this.$route.query.paperId,
        taskId: this.$route.query.taskId,
        employeeId: this.$route.query.employeeId
      }
      this.paperEmployeePaperSummaryGet()
    },
    // 获取 审批 左侧试卷 以及 用户信息
    async paperEmployeePaperSummaryGet () {
      let res = await MBASVCAPIS.PaperApi.paperEmployeePaperSummaryGet(this.params)
      if (res.success) {
        this.paperInfo = res.data.paperInfo
        this.employeeInfo = res.data.employeeInfo
      } else {
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.left-score-info {
  height: 228px;
  width: 186px;
  word-break: break-all;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  margin-right: 20px;
  flex-shrink: 0;

  .paper-score-info,
  .cur-scroe {
    padding: 15px 20px;
  }

  .mb-10 {
    margin-bottom: 10px;
  }

  .paper-score-info {
    margin-bottom: 20px;
  }

  .noPassColor {
    color: #ff6b6b;
  }

  .passColor {
    color: #52c41a;
  }

  .cur-scroe {
    .spot {
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-bottom: 2px;
      margin-right: 3px;
    }

    .passBgColor {
      background-color: #52c41a;
    }

    .noPassBgColor {
      background-color: #ff6b6b;
    }
  }
}
</style>
